/**
 * CTS Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */


import ApiClient from "../ApiClient";
import CommonDeletePayloadModel from '../model/CommonDeletePayloadModel';
import PlatformDto from '../model/PlatformDto';
import SearchingQueryResponseModelPlatformDto from '../model/SearchingQueryResponseModelPlatformDto';

/**
* Platform service.
* @module api/PlatformApi
* @version v1.0.0
*/
export default class PlatformApi {

    /**
    * Constructs a new PlatformApi. 
    * @alias module:api/PlatformApi
    * @class
    * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
    * default to {@link module:ApiClient#instance} if unspecified.
    */
    constructor(apiClient) {
        this.apiClient = apiClient || ApiClient.instance;
    }


    /**
     * Callback function to receive the result of the addPlatformUsingPOST operation.
     * @callback module:api/PlatformApi~addPlatformUsingPOSTCallback
     * @param {String} error Error message, if any.
     * @param {module:model/PlatformDto} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * add platform
     * @param {Object} opts Optional parameters
     * @param {String} opts.description description
     * @param {File} opts.file file
     * @param {String} opts.name name
     * @param {Number} opts.seq seq
     * @param {module:api/PlatformApi~addPlatformUsingPOSTCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/PlatformDto}
     */
    addPlatformUsingPOST(opts, callback) {
      opts = opts || {};
      let postBody = null;

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
        'description': opts['description'],
        'file': opts['file'],
        'name': opts['name'],
        'seq': opts['seq']
      };

      let authNames = ['Authorization'];
      let contentTypes = ['multipart/form-data'];
      let accepts = ['application/json', '*/*', 'multipart/form-data'];
      let returnType = PlatformDto;
      return this.apiClient.callApi(
        '/api/platform/add', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the deletePlatformUsingDELETE operation.
     * @callback module:api/PlatformApi~deletePlatformUsingDELETECallback
     * @param {String} error Error message, if any.
     * @param {Object.<String, {String: Boolean}>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * delete Platform
     * @param {Object} opts Optional parameters
     * @param {Array.<module:model/CommonDeletePayloadModel>} opts.commonDeletePayloadModel 
     * @param {module:api/PlatformApi~deletePlatformUsingDELETECallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Object.<String, {String: Boolean}>}
     */
    deletePlatformUsingDELETE(opts, callback) {
      opts = opts || {};
      let postBody = opts['commonDeletePayloadModel'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Authorization'];
      let contentTypes = ['application/json'];
      let accepts = ['*/*'];
      let returnType = {'String': 'Boolean'};
      return this.apiClient.callApi(
        '/api/platform/delete', 'DELETE',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getPlatformFileUsingGET operation.
     * @callback module:api/PlatformApi~getPlatformFileUsingGETCallback
     * @param {String} error Error message, if any.
     * @param {Object} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * get platform file
     * @param {String} id id
     * @param {Object} opts Optional parameters
     * @param {module:model/String} opts.fileType fileType
     * @param {module:api/PlatformApi~getPlatformFileUsingGETCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Object}
     */
    getPlatformFileUsingGET(id, opts, callback) {
      opts = opts || {};
      let postBody = null;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling getPlatformFileUsingGET");
      }

      let pathParams = {
        'id': id
      };
      let queryParams = {
        'fileType': opts['fileType']
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Authorization'];
      let contentTypes = [];
      let accepts = ['*/*'];
      let returnType = Object;
      return this.apiClient.callApi(
        '/api/platform/file/{id}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getPlatformUsingGET operation.
     * @callback module:api/PlatformApi~getPlatformUsingGETCallback
     * @param {String} error Error message, if any.
     * @param {module:model/PlatformDto} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * get platform
     * @param {String} id id
     * @param {module:api/PlatformApi~getPlatformUsingGETCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/PlatformDto}
     */
    getPlatformUsingGET(id, callback) {
      let postBody = null;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling getPlatformUsingGET");
      }

      let pathParams = {
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Authorization'];
      let contentTypes = [];
      let accepts = ['*/*'];
      let returnType = PlatformDto;
      return this.apiClient.callApi(
        '/api/platform/get/{id}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getPlatformsUsingGET operation.
     * @callback module:api/PlatformApi~getPlatformsUsingGETCallback
     * @param {String} error Error message, if any.
     * @param {module:model/SearchingQueryResponseModelPlatformDto} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * search platform
     * @param {Object} opts Optional parameters
     * @param {Number} opts.from start from
     * @param {Boolean} opts.getAll 
     * @param {String} opts.id id
     * @param {Boolean} opts.isActive active status
     * @param {Boolean} opts.isDeleted delete status
     * @param {String} opts.keyword search keyword
     * @param {Number} opts.limit return size
     * @param {Boolean} opts.withRole 
     * @param {module:api/PlatformApi~getPlatformsUsingGETCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/SearchingQueryResponseModelPlatformDto}
     */
    getPlatformsUsingGET(opts, callback) {
      opts = opts || {};
      let postBody = null;

      let pathParams = {
      };
      let queryParams = {
        'from': opts['from'],
        'getAll': opts['getAll'],
        'id': opts['id'],
        'isActive': opts['isActive'],
        'isDeleted': opts['isDeleted'],
        'keyword': opts['keyword'],
        'limit': opts['limit'],
        'withRole': opts['withRole']
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Authorization'];
      let contentTypes = [];
      let accepts = ['*/*'];
      let returnType = SearchingQueryResponseModelPlatformDto;
      return this.apiClient.callApi(
        '/api/platform/all', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the updatePlatformUsingPATCH operation.
     * @callback module:api/PlatformApi~updatePlatformUsingPATCHCallback
     * @param {String} error Error message, if any.
     * @param {module:model/PlatformDto} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * update platform
     * @param {String} id id
     * @param {Object} opts Optional parameters
     * @param {String} opts.description description
     * @param {File} opts.file file
     * @param {String} opts.name name
     * @param {Number} opts.seq seq
     * @param {module:api/PlatformApi~updatePlatformUsingPATCHCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/PlatformDto}
     */
    updatePlatformUsingPATCH(id, opts, callback) {
      opts = opts || {};
      let postBody = null;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling updatePlatformUsingPATCH");
      }

      let pathParams = {
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
        'description': opts['description'],
        'file': opts['file'],
        'name': opts['name'],
        'seq': opts['seq']
      };

      let authNames = ['Authorization'];
      let contentTypes = ['multipart/form-data'];
      let accepts = ['application/json', '*/*', 'multipart/form-data'];
      let returnType = PlatformDto;
      return this.apiClient.callApi(
        '/api/platform/update/{id}', 'PATCH',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }


}
